import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";

import { ThemeRenderer } from "./ThemeProvider/ThemeHandler";
import ThemeFooter from "./component/ThemeFooter";
import ItemService from "../../services/OrderingServices/ItemService";
import Error500 from "../../pages/AuthenticationInner/Errors/Error500";
import OrganizationService from "../../services/OrderingServices/OrganizationService";

import { Triangle } from "react-loader-spinner";

const OrgPage = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orgDetail, setOrgDetail] = useState();
  const { orgcode } = useParams();
  localStorage.setItem("orgcode", orgcode);

  // ----------------isPublicOrder----------------------
  const isPublicOrder = true;

  const navigate = useNavigate();
  useEffect(() => {
    const fetchOrgDetail = async () => {
      try {
        const response = await OrganizationService.detailByCode(orgcode);
        console.log("🚀 ~ fetchOrgDetail ~ response:", response);
        setOrgDetail(response);

        // Dynamic document title
        document.title = response?.organization?.name || "Organization Page";
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrgDetail();
  }, [orgcode, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ItemService.itemTheme(orgcode);
        console.log("🚀 ~ fetchData ~ response:", response);
        setApiResponse(response);

        // Dynamic document title
        document.title = response?.organization?.name || "Organization Page";
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [orgcode, navigate]);

  if (loading)
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Triangle
          visible={true}
          height="80"
          width="80"
          color="#5B71B9"
          ariaLabel="triangle-loading"
        />
        <h5 className="mt-3">Loading...</h5>
      </div>
    );

  if (error) {
    return (
      <div>
        <Error500 />
      </div>
    );
  }

  return (
    <div>
      {apiResponse &&
        (isPublicOrder ? (
          <ThemeRenderer
            themeKey="Theme2"
            orgInfo={apiResponse}
            orgData={orgDetail}
          />
        ) : (
          <ThemeRenderer
            themeKey="Theme1"
            orgInfo={apiResponse}
            orgData={orgDetail}
          />
        ))}
      <div className="sticky-bottom bg-success">
        <ThemeFooter />
      </div>
    </div>
  );
};

export default OrgPage;
